module.exports = __webpack_public_path__ + "static/media/aus.268fffe7.svg";